export default function (cli) {
  return {
    getTimezones () {
      return cli.get(`${cli.crmApiEndpoint}timezones/`).query()
    },
    addTimezone (data) {
      return cli.post(`${cli.crmApiEndpoint}timezones/`).send(data)
    },
    editTimezone (data) {
      return cli.patch(`${cli.crmApiEndpoint}timezones/${data.pk}/`).send(data)
    },
    deleteTimezone (pk) {
      return cli.del(`${cli.crmApiEndpoint}timezones/${pk}/`).send()
    },
    updateListOrder (data) {
      return cli.post(`${cli.crmApiEndpoint}timezones/update-list-order/`).send(data)
    },
  }
}



// WEBPACK FOOTER //
// ./src/api/crm/timeSettings.js